// extracted by mini-css-extract-plugin
module.exports = {"root":"IconList_root__n4fYM","li":"IconList_li__WINAl","small":"IconList_small__rRNHR","circleIcon":"IconList_circleIcon__ihbU1"};